module.exports = __webpack_public_path__ + "img/Groupright.635526ed.png";